import React from 'react';

const OnlineSupport = () => {
  return (
    <svg viewBox="0 0 24 24">
      <path className="st0" d="M21,10.8c0,1.3-0.3,2.6-0.9,3.8c-1.4,2.9-4.4,4.7-7.6,4.7c-1.3,0-2.6-0.3-3.8-0.9L3,20.3l1.9-5.7  C4.3,13.4,4,12.1,4,10.8c0-3.2,1.8-6.2,4.7-7.6c1.2-0.6,2.5-0.9,3.8-0.9H13c4.3,0.2,7.8,3.7,8,8V10.8z" />
      <g>
        <circle className="st1" cx="9.3" cy="10.5" r="0.5" />
        <circle className="st1" cx="12.5" cy="10.5" r="0.5" />
        <circle className="st1" cx="15.7" cy="10.5" r="0.5" />
      </g>
    </svg>
  );
};

export default OnlineSupport;